module.exports = __webpack_public_path__ + "img/Weapon_73.c79d3721.png";